/**
 * Parent app origins allowed to postMessage into this app (session token, logout requests)
 * and targets for notifying the parent on logout from this app.
 *
 * Use full origins: scheme + host + optional port (e.g. http://localhost:4200).
 * Empty array = do not restrict by origin (accept any; postMessage to parent uses '*').
 */
export const PARENT_APP_ALLOWED_ORIGINS: string[] = [
  // 'http://localhost:4200',
  // 'https://parent.example.com',
];
